import { render } from "./address.vue?vue&type=template&id=6b92c384&scoped=true"
import script from "./address.vue?vue&type=script&lang=js"
export * from "./address.vue?vue&type=script&lang=js"

import "./address.vue?vue&type=style&index=0&id=6b92c384&lang=less&scoped=true"

import exportComponent from "D:\\新建文件夹\\资料\\PC享赫生活\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b92c384"]])

export default __exports__